module.exports = __webpack_public_path__ + "static/media/proj3.c5865d94.jpg";